<template>
  <transition name="fade">
    <v-flex xs12 sm6 md4 v-show="categoriasVisiveis > 0" @click="verCategorias">
      <div class="box">
           <v-checkbox
             :label="classe.Nome"
             v-model="classeSelecionada"
             style="width:90%;"
           ></v-checkbox>
           <div class="classNumber" slot="label">{{ categoriasVisiveis }}</div>
        </div>
    </v-flex>
  </transition>
</template>

<script>
  export default {
    props: {
      classe: Object,
      pesquisa: String
    },
    data () {
      return {
        dialogm1: '',
        dialog: false
      }
    },
    computed: {
      categoriasVisiveis: function () {
        let exp = new RegExp(this.pesquisa.trim(), 'i')
        return this.classe.CategoriasLista.filter(categoria => exp.test(categoria.Nome)).length
      },
      classeSelecionada: {
        get: function () {
          return this.classe.CategoriasLista.filter(categoria => (this.$store.getters.arrayCategorias.indexOf(categoria.Registro) !== -1)).length !== 0
        },
        set: function () {
          return
        }
      }
    },
    methods: {
      verCategorias () {
        this.$emit('visualizar', this.classe)
      },
      pesquisado (value) {
        let exp = new RegExp(this.pesquisa.trim(), 'i')
        return exp.test(value)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.checkbox{
    float: left;
    width: 81%!important;
}
.box{
  background: #eeeeee;
  height: 70px;
  padding-left: 5px;
  border-radius: 1px;
  border: #dcdcdc 1px solid;
}
.classNumber{
  float: left;
  background-color: #6699cd;
  width: 30px;
  height: 30px;
  padding: 5px;
  border-radius: 20px;
  color: #fff;
  margin-top: 18px;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0
}
</style>



// WEBPACK FOOTER //
// Classe.vue?5f90b6b7